import { TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import React, { useEffect, useState, useCallback } from 'react'
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";

export default function CreateCarousel() {
  const getCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = `${now.getMonth() + 1}`.padStart(2, '0');
    const day = `${now.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const [data, setData] = useState([]);
  const [title, setTitle] = useState('');
  const [Carousel, setCarousel] = useState(null);
  const [CarouselSizeExceeds, setCarouselSizeExceeds] = useState('');
  const [fromDate, setFromDaate] = useState(getCurrentDate());
  const [toDate, setToDate] = useState(getCurrentDate());
  const [activeInactive, setActiveInactive] = useState('');
  const [inputBgColor, setInputBgColor] = useState('');
  const [errors, setErrors] = useState('');
  const [DeleteId, setDeleteId] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState([{ label: 'Dashboard', url: '/Dashboard' }]);
  const location = useLocation();

  const handleTitleChange = (e) => {
    const selectedValue = e.target.value
    setTitle(selectedValue)
    setErrors((prevErrors) => ({
      ...prevErrors,
      title: selectedValue ? '' : 'Enter Carousel Title'
    }));
  };

  const handleCarouselClick = () => {
    document.getElementById('Carousel').click();
  };

  const handleCarouselChange = (e) => {
    const selectedCarousel = e.target.files[0];
    if (selectedCarousel) {
      setCarousel(selectedCarousel);

      if (selectedCarousel.size > 5000 * 1024) {
        setCarouselSizeExceeds('Logo size exceeds 5Mb limit.');
        return;
      } else {
        setCarouselSizeExceeds('');
      }

    } else {
      setCarousel(null);
      setCarouselSizeExceeds('');
    }
  };

  const handleRemoveFile = () => {
    setCarousel(null);
    setCarouselSizeExceeds('');
    const CarouselInput = document.getElementById('Carousel');
    if (CarouselInput) {
      CarouselInput.value = '';
    }
  };

  const handleFromDateChange = (e) => {
    setFromDaate(e.target.value)
  };

  const handleToDateChange = (e) => {
    setToDate(e.target.value)
  };

  const handleActiveInactiveChange = (e) => {
    setActiveInactive(e.target.value)
  };

  const handleReset = () => {
    setTitle('');
    setActiveInactive('');
    handleRemoveFile();
  };

  const fetchDetails = useCallback(async () => {
    try {
      const response = await fetch(`/api/getCarousel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ fromDate, toDate, activeInactive }),
      });

      if (response.ok) {
        const Data = await response.json();
        setData(Data);
      } else {
        console.error("Error fetching filtered data");
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  }, [fromDate, toDate, activeInactive]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails, fromDate, toDate, activeInactive]);

  const handleSubmit = async (e) => {
    setLoading(true);
    if (isSubmitting) {
      return;
    }

    if (!title || !Carousel) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        title: !title ? 'News Title is required' : prevErrors.title,
      }));

      if (!Carousel) {
        setCarouselSizeExceeds('Carousel Banner Is Required')
      }

      setLoading(false);
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append('title', title);
    formData.append('Carousel', Carousel);

    try {
      const response = await fetch(`/api/CreateCarousel`, {
        method: 'POST',
        body: formData,
      });
      if (response.ok) {
        const data = await response.json();
        toast.success(data.message);
        handleReset();
        fetchDetails();
      } else {
        const data = await response.json();
        toast.error(data.error);
      }
    } catch (error) {
      console.error('Error uploading', error);
    } finally {
      setLoading(false);
    }
    setIsSubmitting(false);
  }

  const handleSequenceChange = async (CMID, slNo, index) => {
    try {
      const response = await fetch(`/api/UpdateCarouselSequence/${CMID}`, {
        method: 'PUT',
        headers: {
          'content-Type': 'application/json'
        },
        body: JSON.stringify({ slNo }),
      });
      if (response.ok) {
        setInputBgColor(prevColors => ({
          ...prevColors,
          [index]: '#d4edda'
        }));
        fetchDetails();
      } else {
        setInputBgColor(prevColors => ({
          ...prevColors,
          [index]: '#ffcfcf'
        }));
      }
    } catch (error) {
      console.error('Error updating Srno:', error);
      setInputBgColor(prevColors => ({
        ...prevColors,
        [index]: '#ffcfcf'
      }));
    }
  };

  const handleStatusChange = async (CMID, status) => {
    try {
      const response = await fetch(`/api/UpdateCarouselStatus/${CMID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status }),
      })
      if (response.ok) {
        const data = await response.json();
        toast.success(data.message);
        fetchDetails();
      } else {
        const data = await response.json();
        toast.error(data.error)
      }
    } catch (error) {
      console.error('Error');
    }
  };

  const handleConfirmation = async (CMID) => {
    setIsDeleted(true);
    setDeleteId(CMID)
  };

  const handleCancel = async () => {
    setIsDeleted(false);
    setDeleteId('')
  };

  const handleDelete = async (CMID) => {
    try {
      const response = await fetch(`/api/DeleteCarousel/${CMID}`, {
        method: 'DELETE',
      });

      if (response.ok) {
        setData((prevData) => prevData.filter(item => item.CMID !== CMID));
        const data = await response.json();
        toast.success(data.message);
        setIsDeleted(false);
        setDeleteId('')
      } else {
        const data = await response.json();
        toast.error(data.error);
        setIsDeleted(false);
        setDeleteId('')
      }
    } catch (error) {
      console.error('Error deleting Subjects:', error);
    }
  };

  useEffect(() => {
    const currentRoute = location.pathname;
    const newBreadcrumbs = generateBreadcrumbs(currentRoute);
    setBreadcrumbs(newBreadcrumbs);
  }, [location]);

  const generateBreadcrumbs = (currentRoute) => {
    const breadcrumbsArray = [{ label: 'Dashboard', url: '/Dashboard' }];

    const routeParts = currentRoute.split('/').filter(Boolean);
    let urlSoFar = '';
    routeParts.forEach((part) => {
      urlSoFar += `/${part}`;
      breadcrumbsArray.push({ label: part, url: urlSoFar });
    });

    return breadcrumbsArray;
  };

  return (
    <>
      <div className='mt-24 mx-2'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbs.map((breadcrumb, index) => (
              <li key={index} className={`breadcrumb-item${index === breadcrumbs.length - 1 ? ' active' : ''}`}>
                {index === breadcrumbs.length - 1 ? (
                  breadcrumb.label
                ) : (
                  <Link to={breadcrumb.url}>{breadcrumb.label}</Link>
                )}
              </li>
            ))}
          </ol>
        </nav>
        <div className='shadow-sm p-2 mb-3 bg-white rounded'>
          <div className='row d-flex align-items-center'>
            <div className='col-md-6 mb-2'>
              <TextField label="Carousel Title" variant="standard" fullWidth value={title} onChange={handleTitleChange} helperText={errors.title} error={!!errors.title} />
            </div>
            <div className='col-md-6 mb-2'>
              <div className={`d-flex items-center border rounded-4 mt-2 ${Carousel ? 'd-none' : ''}`} onClick={handleCarouselClick}>
                <div>
                  <button className="me-2 rounded-4 btn btn-danger" type="button" >Upload Carousel Banner</button>
                </div>
                <div className="narrowFormats"><p className='mb-0'>JPEG, JPG, PNG | Max: 5 MB</p></div>
              </div>
              <input className="d-none" type="file" id="Carousel" accept="image/*" an onChange={handleCarouselChange} />
              {Carousel && (
                <div className='mt-1'>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <strong>{Carousel.name}</strong> ({(Carousel.size / 1024 / 1024).toFixed(2)} MB)
                    </div>
                    <button className="btn btn-outline-danger btn-sm ms-2" type="button" onClick={handleRemoveFile}>Remove</button>
                  </div>
                </div>
              )}
              {CarouselSizeExceeds && (<span className='text-danger' style={{ fontSize: '12px' }}>{CarouselSizeExceeds}</span>)}
            </div>
            <div className='col-6 mb-2'>
              <Button variant="outlined" color="primary" fullWidth onClick={handleSubmit}>Save</Button>
            </div>
            <div className='col-6 mb-2'>
              <Button variant="outlined" color="secondary" fullWidth onClick={handleReset}>Reset</Button>
            </div>
          </div>
        </div>
        <div className='shadow-sm p-2 mb-3 bg-white rounded'>
          <div className='row d-flex align-items-center'>
            <div className='col-4 mb-2'>
              <TextField label="From Date" variant="standard" fullWidth type='date' value={fromDate} onChange={handleFromDateChange} InputLabelProps={{ shrink: true }} />
            </div>
            <div className='col-4 mb-2'>
              <TextField label="To Date" variant="standard" fullWidth type='date' value={toDate} onChange={handleToDateChange} InputLabelProps={{ shrink: true }} />
            </div>
            <div className='col-4 mb-2'>
              <FormControl variant="standard" fullWidth>
                <InputLabel id="demo-simple-select-standard-label">Status</InputLabel>
                <Select labelId="demo-simple-select-standard-label" id="demo-simple-select-standard" value={activeInactive} onChange={handleActiveInactiveChange}>
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
        <div className='shadow mb-5 rounded scrollOnXaxis' style={{ maxHeight: '100vh', overflowY: 'auto' }}>
          <table className='table table-nowrap mb-0 mt-0'>
            <thead className='table-primary' style={{ position: 'sticky', top: '0', zIndex: '1', marginTop: '1rem' }}>
              <tr style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <th>#</th>
                <th>Sequence</th>
                <th>Title</th>
                <th>Carousel</th>
                <th>Status</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index} style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <td>{index + 1}</td>
                  <td><img src={`/Carousel/${item.CarouselURL}`} alt='Carousel' width='50' height='50' /></td>
                  <td>{item.CarouselTitle}</td>
                  <td><TextField label='Sequence' variant='outlined' type='number' defaultValue={item.SLNo} style={{ backgroundColor: inputBgColor[index] }} onChange={(e) => { handleSequenceChange(item.CMID, e.target.value, index); }} /></td>
                  <td>
                    <div class="form-check form-switch mt-2 mx-2">
                      <input className='form-check-input' checked={item.Status === 1} type="checkbox" role="switch" onChange={() => {
                        const newStatus = item.Status === 1 ? 0 : 1;
                        handleStatusChange(item.CMID, newStatus);
                      }} />
                    </div>
                </td>
                  <td><span className='inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/10' onClick={() => handleConfirmation(item.CMID)}><i className="bi bi-trash3-fill fs-6"></i></span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {isDeleted && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${isDeleted ? 'show' : ''}`} style={{ display: isDeleted ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content shadow-lg p-3 mb-5 bg-white rounded">
            <div className="modal-header">
              <h5 className="modal-title">Delete <strong>Carousel?</strong></h5>
            </div>
            <div className="modal-body">
              <p>This Will Delete Carousel <span className='text-danger'>Permannently</span></p>
              <div className='d-flex flex-row-reverse '>
                <button className='btn btn-danger mx-2' onClick={() => handleDelete(DeleteId)}>Delete</button>
                <button className='btn btn-secondary mx-2' onClick={handleCancel}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div id="preloader">
          <div class="bar-container">
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
            <div class="bar"></div>
          </div>
          <h1>Loading...</h1>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}


